import { render, staticRenderFns } from "./order-imgs.vue?vue&type=template&id=71a6aaf8&scoped=true&"
import script from "./order-imgs.vue?vue&type=script&lang=js&"
export * from "./order-imgs.vue?vue&type=script&lang=js&"
import style0 from "./order-imgs.vue?vue&type=style&index=0&id=71a6aaf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a6aaf8",
  null
  
)

export default component.exports